import { IsEmpty } from '../common/checks';
import Constants from '../common/constants';

const { ReduxAction } = Constants;

const initialState = {
  promoCodes:         [],
  gifts:              [],
  showLoadingOverlay: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ReduxAction.PromoCodesSet:
      return {
        ...state,
        promoCodes: IsEmpty(payload)
          ? []
          : payload,
      };

    case ReduxAction.PromoCodesGiftSet:
      return {
        ...state,
        gifts: IsEmpty(payload)
          ? []
          : payload,
      };

    case ReduxAction.PromoCodesLoadingOverlayShow:
      return {
        ...state,
        showLoadingOverlay: true,
      };

    case ReduxAction.PromoCodesLoadingOverlayHide:
      return {
        ...state,
        showLoadingOverlay: false,
      };
    default:
      return state;
  }
}
